const size = {
  size1: '425px',
  size2: '1024px',
  size3: '1440px',
};

export const device = {
  mobileL: `(max-width: ${size.size1})`,
  laptop: `(max-width: ${size.size2})`,
  laptopL: `(max-width:${size.size3})`,
};
